export default "__VITE_ASSET__CXKtkAw3__"